<div id="welcomePage">
    <div class="container p-3">
        <div class="row py-3">

            <div class="col-lg-8 order-2 order-lg-1 mb-3 pb-3 mb-lg-5 pb-lg-5">
                <div class="py-3">
                    <h1 class="mb-2">Solusi <font class="badgeTitle">Cerdas</font> Pencarian Vendor/Supplier</h1>
                    <h2>Membantu pengadaan barang dan pencarian vendor yang tepat.</h2>
                </div>
            </div>
            <div class="col-lg-4 order-1 order-lg-2">
                <div class="py-1 py-lg-3 text-center text-lg-end">
                    <a href="/">
                        <img class="img-fluid imgLogo" src="/assets/images/logofh-cepetdapet.png">
                    </a>
                </div>
            </div>   
            <div class="col-12 order-3">
                <div class="row">

                    <div class="col-lg-4">
                        <div>
                            <h4><img src="/assets/images/welcome/ic-time-fast@2x.png" class="img-fluid iconWelcome"> Hemat waktu pengadaan barang</h4>
                        </div>
                        <div>
                            <h4><img src="/assets/images/welcome/ic-no-money@2x.png" class="img-fluid iconWelcome"> Tidak ada biaya komisi</h4>
                        </div>
                        <div>
                            <h4><img src="/assets/images/welcome/ic-handshake@2x.png" class="img-fluid iconWelcome"> Cara cerdas mencari vendor</h4>
                        </div>
                        <div>
                            <h4><img src="/assets/images/welcome/ic-free@2x.png" class="img-fluid iconWelcome"> Gratis, tidak ada biaya langganan</h4>
                        </div>
                        <div class="row g-2 py-2">
                            <div class="col-6">
                                <a href="/regis" class="btn btn-primary btn-try w-100">Coba Gratis</a>
                            </div>
                            <div class="col-6">
                                <a href="/" class="btn btn-primary btn-learn w-100"> Pelajari Lebih Lanjut</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-8 text-center text-lg-end">
                        <h2 class="subTitle my-5">“Tinggalkan cara kuno mencari Vendor”</h2>
                    </div>   



                    <div class="col-12 text-lg-end">
                        <div class="row g-2">
                            <div class="col-6 col-lg-12">
                                <!-- <a target="_blank" href="https://wa.me/628111920422" class="btn btn-primary btn-call mb-2 btnMax"><i class="bi bi-whatsapp me-1"></i> Hubungi Kami</a> -->
                                <a href="/contact-us" class="btn btn-primary btn-call mb-2 btnMax"><i class="bi bi-send me-1"></i> Hubungi Kami</a>
                            </div>
                            <div class="col-6 col-lg-12">
                                <a target="_blank" href="mailto:william@cepetdapet.com" class="btn btn-primary btn-mail mb-2 btnMax"><i class="bi bi-envelope me-1"></i> Email Kami</a>
                            </div>
                        </div>
                        <br>
                        
                    </div>
                </div>
            </div>
            

        </div>
    </div>
    <div id="footerPage">
        <div class="container">
            <div class="py-4 text-center">
                <p class="sosmed">Social Media & Newsletter</p>
                <div>
                    <img src="/assets/images/welcome/under_line_yellow.png" class="sosmedImg">
                </div>
                <div class="row row-cols-3 row-cols-sm-3 row-cols-lg-5  justify-content-center py-1">
                    <div class="col">
                        <a target="_blank" href="https://www.instagram.com/cepetdapetsegala/"><img class="sosmedBtn" src="/assets/images/welcome/instagram@2x.png"></a>
                    </div>
                    <div class="col">
                        <a target="_blank" href="https://www.facebook.com/cepetdapetcom"><img class="sosmedBtn" src="/assets/images/welcome/facebook@2x.png"></a>
                    </div> 
                    <div class="col">
                        <a target="_blank" href="https://www.tiktok.com/@cepetdapet.com"><img class="sosmedBtn" src="/assets/images/welcome/tik-tok@2x.png"></a>
                    </div>  
                    <div class="col">
                        <a target="_blank" href="https://www.jpnn.com/news/platform-digital-pencarian-vendor-ini-tawarkan-skema-transaksi-tanpa-komisi"><img class="sosmedBtn" src="/assets/images/welcome/ic-logo-jpnn@2x.png"></a>
                    </div>
                    <div class="col">
                        <a target="_blank" href="https://ekbis.sindonews.com/read/1605873/34/platform-vendor-digital-tawarkan-skema-tanpa-komisi-1755065294"><img class="sosmedBtn" src="/assets/images/welcome/ic-logo-sindonews@2x.png"></a>
                    </div>                                                                             
                </div>
            </div>
            
        </div>
        
    </div>
</div>